import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import React from 'react';
import cx from 'classnames';
import MenuItemProps from '../../types/MenuItemProps';
import style from './Menu.module.css';

/**
 * ## Menu Item for mobile and Tablets
 *
 * Display a line for each link with icon and text.
 *
 * @param {MenuItemProps} props
 * @returns {JSX.Element}
 */
function MenuItemMobile({
  url, isCurrent, icon, name,
}: MenuItemProps) {
  return (
    <Link to={url} className={cx({ [style.active]: isCurrent })}>
      <FontAwesomeIcon icon={icon} />
      <FormattedMessage id={name} tagName="span" />
    </Link>
  );
}
export default MenuItemMobile;
